export const WEBVIEW_RESUME = 'webview-resume'
